module.exports = __webpack_public_path__ + "static/media/mbis_img_1.4ebeb64d.png";